import React from "react"
import { createPortal } from "react-dom"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"

const Action = ({ icon, label, onClick, danger }) => (
  <button
    type="button"
    onClick={onClick}
    className={`inline-flex items-center gap-1.5 h-8 px-3 rounded-full text-[12.5px] font-medium transition-colors ${danger ? "text-rose-300 hover:bg-rose-500/20 hover:text-rose-200" : "text-slate-200 hover:bg-white/10 hover:text-white"}`}
  >
    <FontAwesomeIcon icon={icon} className="text-[11px]" />
    {label}
  </button>
)

const SelectionBar = ({ count, onDuplicateWeek, onDelete, onClear }) => createPortal(
  <div className="pp-float fixed bottom-6 left-1/2 -translate-x-1/2 z-[1100] flex items-center gap-1 pl-4 pr-1.5 py-1.5 rounded-full bg-slate-900 text-white">
    <span className="text-[12.5px] font-semibold tabular-nums mr-2">
      {I18n.t("project_planning.selection.count", { count })}
    </span>
    <Action icon="clone" label={I18n.t("project_planning.selection.duplicate_week")} onClick={onDuplicateWeek} />
    <Action icon="trash-can" label={I18n.t("project_planning.actions.delete")} onClick={onDelete} danger />
    <span className="w-px h-5 bg-white/15 mx-1" />
    <button type="button" onClick={onClear} title={I18n.t("project_planning.selection.clear")} className="grid place-items-center w-8 h-8 rounded-full text-slate-400 hover:bg-white/10 hover:text-white">
      <FontAwesomeIcon icon="xmark" />
    </button>
  </div>,
  document.body,
)

export default SelectionBar
